import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './tm-lc-basic'
import InputTypeDetailed from './tm-lc-detailed'
import InputTypeWithinLease from './tm-lc-within-lease'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed,
  InputTypeWithinLease
}